import { Component, OnInit } from '@angular/core';
import { AccountSettingsService } from '../../../services/account-settings.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

const GLOBAL_SIGNIN_URL_KEY = 'global_signin_url';

@UntilDestroy()
@Component({
    selector: 'hybrid-invalid-account',
    templateUrl: './invalid-account.component.html',
    styleUrls: ['./invalid-account.component.scss']
})
export class InvalidAccountComponent implements OnInit {
    hostname;
    globalSignInUrl;

    constructor(
        private accountSettingsService: AccountSettingsService,
    ) {}

    ngOnInit() {
        document.body.classList.add('background--preauth-refresh');

        this.hostname = window.location.hostname;

        if (window.sessionStorage.getItem(GLOBAL_SIGNIN_URL_KEY)) {
            this.globalSignInUrl = window.sessionStorage.getItem(GLOBAL_SIGNIN_URL_KEY);
        } else {
            this.accountSettingsService.getUnauthenticatedAccountSettings()
                .pipe(untilDestroyed(this))
                .subscribe((settings) => {
                    this.globalSignInUrl = settings.SubscriberSettingsInfo.GlobalSignInUrl;
                    window.sessionStorage.setItem(GLOBAL_SIGNIN_URL_KEY, settings.SubscriberSettingsInfo.GlobalSignInUrl);
                });
        }
    }
}
